module.exports = __webpack_public_path__ + "img/rule-6-posters.2c197298.png";